module.exports = __webpack_public_path__ + "img/floor2_6.9883f35e.jpg";